import React from 'react';
import { Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
const GreenSwitch = withStyles({
    switchBase: {
        '&$checked + $track': {
            backgroundColor: "#f4aa32",
            opacity: 1,
            margin:'auto'
        },
    },
    checked: {},
    track: {}

})(Switch);

const CustomSwitch = (props) => {
    return <GreenSwitch {...props} style={{ color: !props.checked?'#e6e6eb':'white' }}></GreenSwitch>
}
export default CustomSwitch